module.exports = __webpack_public_path__ + "static/img/sc.de7966b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sc.png
// module id = YY4J
// module chunks = 1